import React, {useMemo} from "react";
import router, {Route} from "@/routing/Router";
import AdminLayout from "@widgets/layout/AdminLayout";
import OptionGroupsOverview from "@widgets/menu/optionGroups/OptionGroupsOverview";


const OptionGroups = () => {
    const route: Route = useMemo(() => router.optionGroups, []);

    return (
        <AdminLayout currentPage={route}>
            <OptionGroupsOverview route={route}/>
        </AdminLayout>
    );
};

export default OptionGroups;